import { ReactNode, createContext, useContext } from 'react'

interface PrintInterface {
  doPrint: (nodes: ReactNode) => void
}
const PrintContext = createContext<PrintInterface | undefined>(undefined)
export const usePrint = () => useContext(PrintContext)

type PrintProviderProps = {
  doPrint: (nodes: ReactNode) => void
  children: ReactNode
}
export const PrintProvider = ({
  doPrint,
  children
}: PrintProviderProps) => (
  <PrintContext.Provider value={{
    doPrint: (nodes) => {
      doPrint(nodes)
      setTimeout(() => {
        window.print()
        window.onafterprint = (
          () => {
            doPrint(undefined)
          }
        )
      }, 1000)
    }
  }}>
    {children}
  </PrintContext.Provider>
)